import { render, staticRenderFns } from "./ExcCoinWithLogo.vue?vue&type=template&id=31d918f8&scoped=true&"
import script from "./ExcCoinWithLogo.vue?vue&type=script&lang=js&"
export * from "./ExcCoinWithLogo.vue?vue&type=script&lang=js&"
import style0 from "./ExcCoinWithLogo.vue?vue&type=style&index=0&id=31d918f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d918f8",
  null
  
)

export default component.exports